<script setup>
import { computed } from 'vue';
import { attentionFor, attentionEnabled, countLabel } from './state';
const props = defineProps({ conversationId: { type: Number, required: true } });
const item = computed(() => attentionFor(props.conversationId));
</script>
<template>
  <span v-if="item?.unseen || item?.waiting" class="attention-row-state">
    <strong v-if="item.unseen">● {{ countLabel(item.unseen_messages) }} new</strong>
    <span v-if="item.waiting">⌛ Awaiting reply</span>
  </span>
  <span v-else-if="attentionEnabled() && !item" class="attention-row-pending" role="status">Attention loading</span>
</template>
<style>
.attention-row-state { display:flex;gap:6px;flex-wrap:wrap;color:#8a1c13;font-size:11px;font-weight:600;border-inline-start:3px solid #b42318;padding-inline-start:6px; }
.dark .attention-row-state { color:#ffdad6;border-color:#ff9b8e; }
.attention-row-pending {font-size:11px;color:var(--n-slate-11);}
</style>
